import { render, staticRenderFns } from "./NewImage.vue?vue&type=template&id=1b368120"
import script from "./NewImage.vue?vue&type=script&lang=js"
export * from "./NewImage.vue?vue&type=script&lang=js"
import style0 from "./NewImage.vue?vue&type=style&index=0&id=1b368120&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports